/** 時間領域バッファの RMS。MicLevelMeter / VadDebugOverlay 共用の pure function。 */
export function computeRms(buffer: Float32Array): number {
  if (buffer.length === 0) return 0;
  let sum = 0;
  for (const v of buffer) sum += v * v;
  return Math.sqrt(sum / buffer.length);
}
